import { render } from "./FormPreview.vue?vue&type=template&id=a3f347ea&scoped=true&ts=true"
import script from "./FormPreview.vue?vue&type=script&lang=ts"
export * from "./FormPreview.vue?vue&type=script&lang=ts"

import "./FormPreview.vue?vue&type=style&index=0&id=a3f347ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3f347ea"]])

export default __exports__